import { render, staticRenderFns } from "./InventariosDetail.vue?vue&type=template&id=464015ad&"
import script from "./InventariosDetail.vue?vue&type=script&lang=js&"
export * from "./InventariosDetail.vue?vue&type=script&lang=js&"
import style0 from "./InventariosDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports